// This displays the distributionLocation's marketplace.
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Grid } from "@material-ui/core";
import Menu from "../../../components/Menu.js";
import CustomizedSnackbars from "../../../components/snackBars/Snackbar.js";
import FoodElement from "../Components/FoodElement.jsx";
import FilterColumn from "../Components/FilterColumn.jsx";
import HandleAddAllToBasket from "./../Functions/HandleAddAllToBasket.js";
import LoadCategories from "./../LoadCategories.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import UpdateVisibility from "./../Functions/UpdateVisibility.js";
import DistributionLocationMarketplaceHeaderInformation from "../Components/DistributionLocationMarketplaceHeaderInformation.jsx";
import MarketplaceMessageBanner from "../Components/MarketplaceMessageBanner.jsx";
import Footer from "../../../components/Footer.jsx";
import ShoppingCartCheckoutIcon from "@mui/icons-material/ShoppingCartCheckout";
import AddShoppingCartIcon from "@mui/icons-material/AddShoppingCart";
import SortFoodItemsSelect from "./../Components/SortFoodItemsSelect.jsx";
import HandleFoodItemsSort from "../Functions/HandleFoodItemsSort.js";
import { addGroupingCategories } from "../Functions/FoodGroupingUtils.js";

export default function DistributionLocationMarketplace({
  productDownload,
  userInfo,
  handleUserInfoChange,
  foodItems,
  setFoodItems,
  displayedFoodItems,
  setDisplayedFoodItems,
  currentUser,
  farmCategories,
  totalBasketItems,
  snackBarOpen,
  setSnackBarOpen,
  snackBarMessage,
  setSnackBarMessage,
  handleSnackBarClose,
  selectedCategory,
  setSelectedCategory,
  checkedFarms,
  setCheckedFarms,
  foodGroupings,
}) {
  let emptyMarketplaceMessage =
    "Items will be added soon!  Please come back later.";
  if (displayedFoodItems.length === 0 && foodItems.length !== 0) {
    emptyMarketplaceMessage =
      "There are no items to display for the filters you selected.  Please broaden your search.";
  }

  // Set the default selection for sorting to farm name ascending.
  const [sortBy, setSortBy] = useState("farmNameAsc");

  // When the page loads we want to make sure that the foodItems are sorted correctly.
  useEffect(() => {
    // Sort the foodItems.
    HandleFoodItemsSort(sortBy, foodItems, setFoodItems, setSortBy);
  }, []);

  // The categories of the items along with the categories of the food groupings
  // those items belong to.
  const marketplaceCategories = addGroupingCategories(
    LoadCategories("", farmCategories),
    foodItems,
    foodGroupings,
  );

  // This is to handle the user updating all the foodItems to either checked or unchecked
  // for visbility.
  const handleSwitch = (e) => {
    // Checks if the switch is changing to true or false.
    const checked = e.target.checked;

    // This makes sure that when items are updated the master foodItem list to prevent
    // any problems when changing the Visibility while there are filters or categories selected.
    let foodItemsTemp = [...foodItems];

    // Cycle through all the foodItems to update them all.
    displayedFoodItems.forEach((foodItem, index) => {
      // Checks if the distributionLocationVisible exists first.  If it doesn't then
      // just create an empty array for it.
      if (!foodItem.distributionLocationVisible) {
        foodItem.distributionLocationVisible = [];
      }
      // Checks to see if the user is making the item visible.
      if (checked) {
        // Checks to see if the item is already visible as if it is we don't need
        // to do anything.
        if (!foodItem.distributionLocationVisible.includes(userInfo.userId)) {
          // Takes the updated displayedFoodItems and updates the temporary array.
          foodItemsTemp = UpdateVisibility(
            userInfo,
            foodItem,
            checked,
            foodItemsTemp,
            setFoodItems,
          );
        }
      }
      // If the user is making the item unvisible to users.
      // Checks to see if the item is already unvisible.
      else if (foodItem.distributionLocationVisible.includes(userInfo.userId)) {
        // Takes the updated displayedFoodItems and updates the temporary array.
        foodItemsTemp = UpdateVisibility(
          userInfo,
          foodItem,
          checked,
          foodItemsTemp,
          setFoodItems,
        );
      }
    });
    // When the loop has finished then update the hook.
    setFoodItems([...foodItemsTemp]);
  };

  // This means that all items are visible and so the switch is set to true.
  let allVisible = true;

  // Cycle through the foodItems to determine if they are all visible or not.
  displayedFoodItems.forEach((foodItem) => {
    // First check if the distributionLocationVisible exists and if it doesn't then
    // set it to an empty array and make allVisible false.
    if (!foodItem.distributionLocationVisible) {
      foodItem.distributionLocationVisible = [];
      allVisible = false;
    }
    // If distributionLocationVisible does exist then check if this distribution
    // location is set to true for this foodItem.
    // If it's not contained in the distributionLocationVisible array.
    else if (!foodItem.distributionLocationVisible.includes(userInfo.userId)) {
      // Set the all visible to false.
      allVisible = false;
    }
  });

  // Counts if there are any items that the user has pressed the plus button but not
  // yet added to the basket.
  let addAllVisible = 0;
  // Counts up the displayed items quantities to see if any items need to be added to
  // the basket.
  displayedFoodItems.forEach((displayedFoodItem) => {
    addAllVisible += displayedFoodItem.quantity;
  });

  return (
    <div
      style={{ background: "rgb(244, 249, 224)", minWidth: "950px" }}
      id="home"
    >
      <Menu />
      {userInfo.marketplaceMessageEnabled && (
        <div
          style={{
            margin: "-1px",
            padding: "1px",
            background: "rgb(159 191 89)",
          }}
        >
          <MarketplaceMessageBanner pickupLocationDetails={userInfo} />
        </div>
      )}
      <div className="Marketplace-Page-Header">
        <DistributionLocationMarketplaceHeaderInformation
          userInfo={userInfo}
          productDownload={productDownload}
        />
      </div>
      <div className="Page-Market" id="pageMarket">
        <Grid container spacing={2}>
          {foodItems.length !== 0 && (
            <Grid item xs={3}>
              <div className="Checkout-Add-Items-Buttons">
                {totalBasketItems > 0 && (
                  <Link
                    style={{ textDecoration: "none", marginBottom: "10px" }}
                    to="/Basket"
                  >
                    <Button
                      endIcon={<ShoppingCartCheckoutIcon size="large" />}
                      variant="contained"
                      style={{
                        background: "rgb(21, 101, 192)",
                        color: "white",
                        width: "100%",
                      }}
                    >
                      HEAD TO CHECKOUT
                    </Button>
                  </Link>
                )}
                {addAllVisible > 0 && (
                  <Button
                    onClick={() =>
                      HandleAddAllToBasket(
                        displayedFoodItems,
                        setDisplayedFoodItems,
                        setSnackBarOpen,
                        setSnackBarMessage,
                        userInfo,
                        handleUserInfoChange,
                      )
                    }
                    endIcon={<AddShoppingCartIcon />}
                    variant="contained"
                    style={{
                      backgroundColor: "#9FBF59",
                      color: "white",
                      marginBottom: "10px",
                      width: "100%",
                    }}
                  >
                    ADD ALL ITEMS TO CART
                  </Button>
                )}

                <FilterColumn
                  marketplaceCategories={marketplaceCategories}
                  foodItems={foodItems}
                  setDisplayedFoodItems={setDisplayedFoodItems}
                  checkedFarms={checkedFarms}
                  setCheckedFarms={setCheckedFarms}
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  foodGroupings={foodGroupings}
                />
              </div>
            </Grid>
          )}
          <Grid item xs>
            {displayedFoodItems.length !== 0 && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "10px",
                }}
              >
                <FormControlLabel
                  label="Change All Visibility"
                  control={
                    <Switch
                      checked={allVisible}
                      onChange={(e) => handleSwitch(e)}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  }
                />

                <SortFoodItemsSelect
                  foodItems={foodItems}
                  setFoodItems={setFoodItems}
                  sortBy={sortBy}
                  setSortBy={setSortBy}
                  userInfo={userInfo}
                />
              </div>
            )}
            {displayedFoodItems.length !== 0 ? (
              <span>
                <div className="Food-List">
                  {displayedFoodItems.map((row, index) => (
                    <FoodElement
                      key={index}
                      index={index}
                      row={row}
                      currentUser={currentUser}
                      userInfo={userInfo}
                      handleUserInfoChange={handleUserInfoChange}
                      foodItems={foodItems}
                      setFoodItems={setFoodItems}
                      displayedFoodItems={displayedFoodItems}
                      setDisplayedFoodItems={setDisplayedFoodItems}
                      setSnackBarOpen={setSnackBarOpen}
                      setSnackBarMessage={setSnackBarMessage}
                    />
                  ))}
                </div>
                <div>
                  Icons made by{" "}
                  <a
                    href="https://www.flaticon.com/authors/photo3idea-studio"
                    title="photo3idea_studio"
                  >
                    photo3idea_studio
                  </a>{" "}
                  from{" "}
                  <a href="https://www.flaticon.com/" title="Flaticon">
                    www.flaticon.com
                  </a>
                </div>
              </span>
            ) : (
              <span>
                <span>
                  <h3 className="EmptyMarketplace">
                    {emptyMarketplaceMessage}
                  </h3>
                </span>
              </span>
            )}
          </Grid>
        </Grid>
        <CustomizedSnackbars
          message={snackBarMessage}
          open={snackBarOpen}
          handleClose={handleSnackBarClose}
        />
      </div>
      <Footer />
    </div>
  );
}
